import {connect} from 'react-redux';

import {makeMapDispatchToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {CardModel} from '../../../models/api/cardModel';
import {VisualContactModel} from '../../../models/api/visualContactModel';
import {
  contactDetailsAddCardToAccountAsyncAction,
  contactDetailsOpenCreateNewAccountFormAsyncAction,
} from '../../../store/panels/contacts/contactDetailsPanelActions';
import {ContactDetailsPanelId} from '../../../store/panels/panelStateBase';
import {ContactDetailsNoAccount} from './contactDetailsNoAccount';

/*
 * Props.
 */

interface ContactDetailsNoAccountContainerProps {
  panelId: ContactDetailsPanelId;
  card: CardModel | undefined;
  contact: VisualContactModel | undefined;
}

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps<ContactDetailsNoAccountContainerProps>()(
  ({panelId, card, contact}) => ({
    onAddCardToAccount: (accountId: number) =>
      contactDetailsAddCardToAccountAsyncAction(panelId, accountId, card, contact),
    onOpenCreateNewAccountForm: (searchText: string) =>
      contactDetailsOpenCreateNewAccountFormAsyncAction(panelId, searchText, card, contact),
  }),
);

export const ContactDetailsNoAccountContainer = connect(null, mapDispatchToProps)(ContactDetailsNoAccount);
